import React from 'react';
import { useTranslation } from 'react-i18next';

export function UnderlineColor({ obj, handleUnderline }) {
  const { t } = useTranslation('common');
  return (
    <div className="pl-0 pr-2 py-3">
      <p className="mb-2 f-14 text-medium">&nbsp;</p>
      <div className="bold-check-control mr-2">
        <input type="checkbox" id="underline" onChange={handleUnderline} checked={obj?.otherConfiguration?.underline === true} name="underline" />
        <label htmlFor="underline" title={t('CUSTOM_MODULES.LIBRARY.CONTROL_CONFIG.BOLD_CONFIG.BOLD')}>
          <span className="icon-Underline f-24 cursor-pointer" />
        </label>
      </div>
    </div>
  );
}

export default UnderlineColor;
